import React from 'react';
import DynamicLabelInput from './DynamicLabelInput';

const renderField = ({ input, label, fieldInfo, showSuccess, showLabel, type, autoComplete, meta: { asyncValidating, touched, error, valid, invalid, warning } }) => (
  <div className={`form-group ${touched && invalid ? 'has-error' : ''} ${touched && valid && showSuccess ? 'has-success' : ''}`}>
    <div className={asyncValidating ? 'async-validating' : ''}>
        <DynamicLabelInput {...input}
        	className="form-control"
        	showLabel={showLabel === undefined && (process.env.PAGE === 'montemar')}
          placeholder={label}
          fieldInfo={fieldInfo}
        	type={type}
        	autoComplete={autoComplete}/>
        <div className="help-block">
        {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
  </div>
)

export default renderField;


/** WEBPACK FOOTER **
 ** ./src/components/RenderField.js
 **/